<template>
  <div id="aprication">
    <div class="header-div">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%;margin-top: 20px;"
      row-key="menuId"
      border
      size="medium"
      :tree-props="{children: 'children'}">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column prop="name" label="名称" width="200"></el-table-column>
      <el-table-column prop="iconBiaoQian" label="图标" width="90">
        <template slot-scope="scope">
          <span v-html="scope.row.iconBiaoQian"></span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" width="90" :formatter="dataFormat"></el-table-column>
      <el-table-column prop="url" label="地址" width="360"></el-table-column>
      <el-table-column prop="perms" label="权限标识" width="360"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope" v-if="$hasPerm('sys:menu:edit,sys:menu:add,sys:menu:remove')">
          <el-button style="margin-right: 5px;" v-if="$hasPerm('sys:menu:edit')" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑<i class="el-icon-edit"></i></el-button>
          <el-button style="margin-right: 5px;" v-if="$hasPerm('sys:menu:add')" size="mini" @click="handleAddNext(scope.$index, scope.row)">添加下级<i class="el-icon-plus"></i></el-button>
          <el-popconfirm title="确定删除吗？" @onConfirm="handleDelete(scope.$index, scope.row)">
            <el-button size="mini" slot="reference" v-if="$hasPerm('sys:menu:remove')" type="danger">删除<i class="el-icon-delete"></i></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
  </div>
</template>
<script>
  import Edit from './edit'

  export default {
    name: 'MenuList',
    components: {
      Edit
    },
    data() {
      return {
        tableData: [],
        editVisible: false
      }
    },
    methods: {
      handleCurrentChange() {
        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/sys/menu/tree2'),
          method: 'post'
        }).then(r => {
          this.tableData = r.data.data;
        }).finally(r => {})

      },
      //格式化
      dataFormat: function (row, column) {
        let data = row[column.property];
        if(data == 0){return '目录'}
        if(data == 1){return '菜单'}
        if(data == 2){return '按钮'}
        return data;
      },
      handleEdit(index, row) {
        let menuId = row.menuId;
        let name = row.name;
        this.editVisible = true;
        this.$nextTick(() => {
          this.$refs.edit.int(menuId,name,1);
        })
      },
      handleAddNext(index, row) {
        let menuId = row.menuId;
        let name = row.name;
        this.editVisible = true;
        this.$nextTick(() => {
          this.$refs.edit.int(menuId,name,2);
        })
      },
      handleDelete(index, row) {
        let menuId = row.menuId;

        this.$httpTAG({
          url: this.$httpTAG.adornUrl('/business/sys/menu/remove'),
          method: 'post',
          data: this.$httpTAG.adornData({
            'menuId': menuId
          })
        }).then(res => {
          if (res.data.code == 0) {
            this.$notify({
              title: '操作成功！',
              type: 'success',
              offset: 600
            });
            this.handleCurrentChange(1);
          } else {
            this.$message({ // 失败
              type: 'error',
              message: res.data.msg
            })
          }
        }).finally(r => {})

      }
    },
    created: function () {
      this.handleCurrentChange();
    }
  }
</script>
<style scoped>
  .header-div {
    margin-bottom: 5px;
    height: 25px;
    float: left;
    width: 50%;
  }
  .el-button + .el-button{
    margin-left: 0px;
  }
</style>
